module.exports = __webpack_public_path__ + "media/thumbnails/body-style-3-e45b7171.svg";